import styled from "styled-components";
import type { UscObjectFitType } from "../../../../../../shared-logic/types/UscCommonTypes";

export const Image = styled.img<{ objectFit: UscObjectFitType }>`
    max-width: 1500px;
    height: 100%;
    object-fit: ${({ objectFit }) => objectFit};
    border-radius: 8px;

    &[data-aspect-ratio="16:9"] {
        width: 75vw;
        aspect-ratio: 16/9;
    }

    &[data-aspect-ratio="4:3"] {
        aspect-ratio: 4/3;
    }
`;

export const Wrapper = styled.div`
    position: relative;
    flex: 0 0 auto;
    scroll-snap-align: center;

    &:first-child {
        margin-left: ${({ theme }) => !theme.isRTL && "50%"};
        margin-right: ${({ theme }) => theme.isRTL && "50%"};
    }

    &:last-child img {
        margin-left: ${({ theme }) => theme.isRTL && "50%"};
        margin-right: ${({ theme }) => !theme.isRTL && "50%"};
    }
`;

export const Content = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;
